import { useQuery } from "@tanstack/react-query";
import { getUpLiveStatus } from "@/lib/client/apex";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";

export function UpCard() {
  const { data } = useQuery({
    queryKey: ["up-card", "live"],
    queryFn: getUpLiveStatus,
  });

  return (
    <Card>
      <CardContent>
        <CardHeader className="items-center space-y-2 flex flex-col">
          <a
            href={
              data?.live_status === 1
                ? "https://live.bilibili.com/23638998"
                : "https://space.bilibili.com/423228676"
            }
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative size-16 rounded-full border-2 border-foreground">
              <img
                className="aspect-square object-cover size-full rounded-full overflow-clip"
                referrerPolicy="no-referrer"
                src="//i1.hdslb.com/bfs/face/48b79aa0c49df8ebfe708715ea8451253c289289.jpg@128w_128h_1c_1s.webp"
                alt="avatar"
              />

              {data?.live_status === 1 && (
                <div className="text-[10px] text-white absolute -bottom-2 inset-x-0 flex items-center justify-center">
                  <p className="bg-[#FB7299] rounded-full border border-white px-1">
                    <span className="translate-x-[.15px] inline-block">直播中</span>
                  </p>
                </div>
              )}
            </div>
          </a>

          <p className="text-xl font-bold text-center">apex刘大莽</p>

          <p className="text-xs text-center">
            陪微信qq: 1014361049 商务: lijitao5072495
            <br />
            猛男甜妹：xqepw666 @小企鹅陪玩电竞俱乐部KOOK727272
          </p>
        </CardHeader>

        <div className="flex space-x-4 items-center justify-center mt-2">
          <a href="https://space.bilibili.com/423228676">
            <Button className="bg-[#FB7299] hover:bg-[#FB7299]/80 text-white">Bilibili</Button>
          </a>

          <a href="https://live.bilibili.com/23638998">
            <Button className="bg-[#FB7299] hover:bg-[#FB7299]/80 text-white">直播间</Button>
          </a>

          <a href="https://oopz.cn/i/yn54nE">
            <Button>OOPZ</Button>
          </a>
        </div>
      </CardContent>
      {data?.live_status === 1 && (
        <CardFooter className="flex items-center justify-center text-sm space-x-2">
          <div className="size-3 relative">
            <div className="absolute inset-0 bg-red-500 rounded-full"></div>
            <div className="absolute inset-0 animate-ping bg-red-500 rounded-full"></div>
            <div className="absolute inset-0 animate-ping delay-500 bg-red-500 rounded-full"></div>
          </div>

          <p>{data?.title}</p>

          <a href="https://live.bilibili.com/23638998">
            <Button variant="link" className="p-0 size-auto text-blue-500 underline">
              快去围观
            </Button>
          </a>
        </CardFooter>
      )}
    </Card>
  );
}
